export default __webpack_public_path__ + "static/media/Mutuo Press Release -2021 12 19.62548fd9.pdf";